import React from "react";

export default function familyChildrenColumns(onOpenModal) {
  return [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      ellipsis: false,
      render: (text, record) => (
        <a onClick={() => onOpenModal(record)}>{text}</a>
      ),
    },
    {
      title: "PAN",
      dataIndex: "pan",
      key: "pan",
      ellipsis: false,
      render: (text, record) => (
        <a onClick={() => onOpenModal(record)}>{text}</a>
      ),
    },
    {
      title: "Total Investment",
      dataIndex: ["totals", "total_investment"],
      key: "total_investment",
      align: "right",
      ellipsis: false,
      responsive: ["md"],
      render: (val) =>
        val !== null && val !== undefined
          ? `₹${Number(val).toLocaleString()}`
          : "-",
    },
    {
      title: "Redemption / Switches",
      children: [
        {
          title: "Cost Amount",
          dataIndex: ["totals", "redemption_cost_amount"],
          key: "redemption_cost_amount",
          align: "right",
          ellipsis: false,
          render: (val) =>
            val !== null && val !== undefined
              ? `₹${Number(val).toLocaleString()}`
              : "-",
        },
        {
          title: "Actual Amount",
          dataIndex: ["totals", "redemption_actual_amount"],
          key: "redemption_actual_amount",
          align: "right",
          ellipsis: false,
          render: (val) =>
            val !== null && val !== undefined
              ? `₹${Number(val).toLocaleString()}`
              : "-",
        },
      ],
    },
    {
      title: "Remaining Value",
      children: [
        {
          title: "Cost Amount",
          dataIndex: ["totals", "remaining_cost_value"],
          key: "remaining_cost_value",
          align: "right",
          ellipsis: false,
          render: (val) =>
            val !== null && val !== undefined
              ? `₹${Number(val).toLocaleString()}`
              : "-",
        },
        {
          title: "Current Value",
          dataIndex: ["totals", "current_value"],
          key: "current_value",
          align: "right",
          ellipsis: false,
          render: (val) =>
            val !== null && val !== undefined
              ? `₹${Number(val).toLocaleString()}`
              : "-",
        },
      ],
    },
  ];
}
